import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const PaymentConditionList = () => {
  const [paymentConditions, setPaymentConditions] = useState([]);
  const [newPaymentCondition, setNewPaymentCondition] = useState({ name: '' });
  const [editPaymentConditionId, setEditPaymentConditionId] = useState(null);
  const [editPaymentConditionName, setEditPaymentConditionName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPaymentConditions = async () => {
      try {
        const response = await api.get('/paymentconditions');
        setPaymentConditions(response.data);
        setLoading(false);
      } catch (err) {
        setError('Fehler beim Abrufen der Zahlungsbedingungen');
        setLoading(false);
      }
    };

    fetchPaymentConditions();
  }, []);

  const handleAddPaymentCondition = async () => {
    const name = newPaymentCondition.name.trim();

    if (!name) {
      alert('Bitte einen Namen für die Zahlungsbedingung angeben.');
      return;
    }

    try {
      const response = await api.post('/paymentconditions', { name });
      setPaymentConditions([...paymentConditions, response.data]);
      setNewPaymentCondition({ name: '' });
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Fehler beim Hinzufügen der Zahlungsbedingung';
      alert(errorMessage);
    }
  };

  const handleEditPaymentCondition = (condition) => {
    setEditPaymentConditionId(condition.id);
    setEditPaymentConditionName(condition.name);
  };

  const handleCancelEdit = () => {
    setEditPaymentConditionId(null);
    setEditPaymentConditionName('');
  };

  const handleSavePaymentCondition = async (id) => {
    const name = editPaymentConditionName.trim();

    if (!name) {
      alert('Bitte einen Namen für die Zahlungsbedingung angeben.');
      return;
    }

    try {
      const response = await api.put(`/paymentconditions/${id}`, { name });
      setPaymentConditions(paymentConditions.map((condition) => (
        condition.id === id ? response.data : condition
      )));
      handleCancelEdit();
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Fehler beim Aktualisieren der Zahlungsbedingung';
      alert(errorMessage);
    }
  };

  const handleDeletePaymentCondition = async (id) => {
    try {
      await api.delete(`/paymentconditions/${id}`);
      setPaymentConditions(paymentConditions.filter((condition) => condition.id !== id));
      if (editPaymentConditionId === id) {
        handleCancelEdit();
      }
    } catch (err) {
      alert('Fehler beim Löschen der Zahlungsbedingung');
    }
  };

  if (loading) return <div>Lade Zahlungsbedingungen...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="p-4" style={{ maxWidth: '600px', margin: 'auto' }}>
      <Helmet>
        <title>Zahlungsbedingungen verwalten</title>
        <meta name="description" content="Zahlungsbedingungen verwalten" />
      </Helmet>
      <h2>Zahlungsbedingungen</h2>

      <div
        style={{
          display: 'flex',
          gap: '20px',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <input
          type="text"
          value={newPaymentCondition.name}
          onChange={(e) => setNewPaymentCondition({ name: e.target.value })}
          placeholder="Name der Zahlungsbedingung"
        />
        <button
          type="button"
          onClick={handleAddPaymentCondition}
          style={{
            padding: '10px 10px',
            background: '#28a745',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '-15px',
          }}
        >
          Hinzufügen
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {paymentConditions.map((condition) => (
            <tr key={condition.id}>
              <td>{condition.id}</td>
              <td>
                {editPaymentConditionId === condition.id ? (
                  <input
                    type="text"
                    value={editPaymentConditionName}
                    onChange={(e) => setEditPaymentConditionName(e.target.value)}
                    placeholder="Name der Zahlungsbedingung"
                  />
                ) : (
                  condition.name
                )}
              </td>
              <td>
                <div style={{ display: 'flex', gap: '5px' }}>
                  {editPaymentConditionId === condition.id ? (
                    <>
                      <button
                        type="button"
                        onClick={() => handleSavePaymentCondition(condition.id)}
                        style={{
                          padding: '5px 10px',
                          background: '#28a745',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                      >
                        Speichern
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelEdit}
                        style={{
                          padding: '5px 10px',
                          background: '#6c757d',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                      >
                        Abbrechen
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={() => handleEditPaymentCondition(condition)}
                        style={{
                          padding: '5px 10px',
                          background: '#007bff',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                      >
                        Bearbeiten
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeletePaymentCondition(condition.id)}
                        style={{
                          padding: '5px 10px',
                          background: '#dc3545',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                      >
                        Löschen
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentConditionList;
